




















import { Component, Prop, Vue } from "vue-property-decorator";
import CzGlow from "./CzGlow.vue";

@Component({ components: { CzGlow } })
export default class CzRing extends Vue {
  @Prop({ type: Number, default: 0 }) value!: number;
  @Prop({ type: Number, default: 1 }) max!: number;
  @Prop({ type: String, default: "" }) label!: string;
  @Prop({ type: Number, default: 72 }) size!: number;

  get half() {
    return this.size / 2;
  }

  get radius() {
    return this.half - 4;
  }

  get text() {
    return this.value + "/" + this.max;
  }

  get dash() {
    const length = 2 * Math.PI * this.radius;
    const ratio = this.max > 0 ? Math.min(1, Math.max(0, this.value / this.max)) : 0;
    return (length * ratio).toFixed(1) + " " + length.toFixed(1);
  }
}
